import { QueryClient } from "@tanstack/react-query";

let queryClientInstance = null;

export const getQueryClient = () => {
  if (!queryClientInstance) {
    queryClientInstance = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retryOnMount: false,
          retry: false,
          staleTime: 5 * 60 * 1000 // 5 minutes
        }
      }
    });
  }
  return queryClientInstance;
};
